<template>
  <div
    id="accordion-item"
    class="cf-accordion__item"
    :class="{ 'cf-accordion__item--open': open }"
  >
    <button
      id="accordion-item-header"
      type="button"
      class="cf-accordion__item-header"
      :aria-controls="`item-${itemId}`"
      :aria-expanded="open"
      @click="selectItem"
    >
      <div class="cf-accordion__item-header-content">
        <slot name="item-title" />
      </div>

      <div class="cf-accordion__item-indicator">
        <span class="cf-icon cf-icon--smedium far fa-angle-right" />
      </div>
    </button>

    <transition :name="animated ? 'fade-down' : ''">
      <div
        v-show="open"
        class="cf-padding-top-12"
        :aria-hidden="!open"
      >
        <slot name="item-content" />
      </div>
    </transition>
  </div>
</template>


<script>
  export default {
    name: 'CfAccordionItem',

    props: {
      animated: {
        type: Boolean,
        default: true
      },

      itemId: {
        type: Number,
        required: true
      },

      open: {
        type: Boolean,
        default: false
      }
    },

    methods: {
      selectItem() {
        this.$emit('accordion-item-selected', this.itemId);
      }
    }
  };
</script>
